var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-check-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    fill: "#000000",
    transform: "translate(42.666667, 42.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.757355,253.659504 L411.575978,279.67383 L291.053891,436.352543 L188.618568,346.721636 L216.714765,314.611697 L284.928,374.314667 L377.757355,253.659504 Z M186.666667,192 C246.976161,192 296.152141,241.030192 298.573247,302.451464 L298.666667,307.2 L298.666,321.456 L281.877333,343.274667 L214.709805,284.506445 L158.515501,348.728507 L198.825,383.999 L7.10542736e-15,384 L7.10542736e-15,307.2 C7.10542736e-15,245.167377 47.6682427,194.586369 107.383368,192.096089 L112,192 L186.666667,192 Z M149.333333,7.10542736e-15 C190.570595,7.10542736e-15 224,33.4294053 224,74.6666667 C224,114.529353 192.762078,147.096031 153.430084,149.222851 L149.333333,149.333333 C108.096072,149.333333 74.6666667,115.903928 74.6666667,74.6666667 C74.6666667,34.8039807 105.904589,2.23730242 145.236582,0.110482405 L149.333333,7.10542736e-15 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateUserIcon);
export default __webpack_public_path__ + "static/media/activate-user-icon.4872a8dc3bb7d36b7fa07b45622d495f.svg";
export { ForwardRef as ReactComponent };